<p *ngIf="error" role="alert">{{ error }}</p>
<tt-page>
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-tabs [ttSelectedId]="activeStatus" (ttSelectedIdChange)="onStatusChanged($event)">
            <tt-tab ttId="ACT" ttLabel="active"></tt-tab>
            <tt-tab ttId="NOT_ACT" ttLabel="not_active"></tt-tab>
            <tt-tab ttId="ALL" ttLabel="all"></tt-tab>
        </tt-tabs>
        <tt-list [ttData]="items" ttBackStyle [ttGoto]="false" [ttClickable]="canSelect" (ttClick)="select($event.item)"></tt-list>
        <tt-button ttText="add_new_labour" ttIcon="fas fa-plus" ttTextAlign="left" ttIconPullRight (ttClick)="addLabour($event)"></tt-button>
    </tt-card>
</tt-page>
